import { DropdownMenuItemType, IDropdownOption } from "@fluentui/react";

import { PermissionsAction } from "@/common/types/permissions.types";

export const MIN_WORDS_REASON = 3;

export const ACTIONS_REQUIRING_REASON = [
  PermissionsAction.CANCEL,
  PermissionsAction.REJECT,
  PermissionsAction.APPROVE_COMMERCIALLY
];

export const ACTION_REASONS: Partial<
  Record<PermissionsAction, IDropdownOption[]>
> = {
  [PermissionsAction.APPROVE_COMMERCIALLY]: [
    { key: "1", text: "Negociação", itemType: DropdownMenuItemType.Header },
    { key: "2", text: "Isenção de Adesão B ou Ativação C" },
    { key: "3", text: "Personalização de valores do Combo" },
    { key: "4", text: "Pagamento de ativação Em Fatura" },
    { key: "5", text: "Valor da Ativação C como cota capital" },

    { key: "6", text: "-", itemType: DropdownMenuItemType.Divider },
    { key: "7", text: "Operações", itemType: DropdownMenuItemType.Header },
    {
      key: "8",
      text: "Reativação, renovação, transferência ou portabilidade"
    },
    { key: "9", text: "Renovação sem cobrança de Adesão B e Ativação C" },
    {
      key: "10",
      text: "Portabilidade interna sem cobrança do valor da Adesão B e Ativação C"
    },

    { key: "11", text: "-", itemType: DropdownMenuItemType.Divider },
    { key: "12", text: "Parceiros", itemType: DropdownMenuItemType.Header },
    { key: "13", text: "TT sem cobrança de Ativação C, via PIX" },
    {
      key: "14",
      text: "TT ABEPOM sem cobrança de Ativação C, com da Adesão B em fatura"
    },
    {
      key: "15",
      text: "ABEPOM com cobrança de Ativação C + Adesão B em fatura"
    },
    {
      key: "16",
      text: "Agente/funcionário Sicoob sem cobrança de Adesão B e Ativação C"
    },
    {
      key: "18",
      text: "Conta Zero com isenção da Adesão B e custo da Ativação C em fatura"
    },
    {
      key: "19",
      text: "PMC com cobrança da Ativação C via PIX e isenção da Adesão B"
    },
    {
      key: "20",
      text: "Parceiros em intercooperação com cobrança da Ativação C em Fatura"
    },
    {
      key: "21",
      text: "Parceiros em intercooperação com cobrança de Adesão B em Fatura"
    },

    { key: "22", text: "-", itemType: DropdownMenuItemType.Divider },
    { key: "24", text: "CNPJ", itemType: DropdownMenuItemType.Header },
    {
      key: "24",
      text: "Cooperdiretos CNPJ (já cooperado) com cobrança da Ativação C via fatura"
    },
    {
      key: "25",
      text: "Cooperdiretos CNPJ (Combo Smart) com cobrança em fatura"
    },
    { key: "26", text: "BL com cobrança da ativação em fatura para CNPJ" },
    {
      key: "27",
      text: "Link dedicado com cobrança da ativação em fatura para CNPJ"
    },
    { key: "28", text: "Tag com cobrança do adesivo em fatura para CNPJ" },
    { key: "29", text: "PABX com cobrança da ativação em fatura para CNPJ" },
    { key: "30", text: "Starmove com cobrança da ativação em fatura para CNPJ" }
  ]
};
